$(document).ready(function() {
    let forms = $('form');
    function gtmPush(event, formId) {
        if (typeof dataLayer !== 'undefined') {
            dataLayer.push({
                event: event,
                formName: formId
            });
        }
    }

    function checkGA() {
        if (typeof ga === 'function') {
            gtmSetup();
        } else {
            setTimeout(checkGA, 3000);
        }
    }

    function gtmSetup() {
        if (forms) {
            forms.each(function (position, $form) {
                let freeform = $form.freeform;
                if (freeform) {
                    ga(function () {
                        var tracker = ga.getAll()[0];

                        if (freeform.form.GATRACKID !== 'undefined') {
                            freeform.form.GACLIENTID.value = tracker.get('clientId');
                            freeform.form.GAUSERID.value = tracker.get('userId');
                            freeform.form.GATRACKID.value = tracker.get('trackingId');
                        }
                    });
                }
            });
        }
    }

    function setUtmValues(freeform, queryParams) {
        if ('utm_source' in queryParams) {
            Cookies.set('utm_source', queryParams['utm_source'][0], { expires: 1 });
        }
        if ('utm_medium' in queryParams) {
            Cookies.set('utm_medium', queryParams['utm_medium'][0], { expires: 1 });
        }
        if ('utm_campaign' in queryParams) {
            Cookies.set('utm_campaign', queryParams['utm_campaign'][0], { expires: 1 });
        }
        if ('utm_content' in queryParams) {
            Cookies.set('utm_content', queryParams['utm_content'][0], { expires: 1 });
        }

        if (freeform.form.utmSource !== 'undefined' && Cookies.get('utm_source')) {
            freeform.form.utmSource.value = Cookies.get('utm_source');
        }

        if (freeform.form.utmMedium !== 'undefined' && Cookies.get('utm_medium')) {
            freeform.form.utmMedium.value = Cookies.get('utm_medium');
        }

        if (freeform.form.utmCampaign !== 'undefined' && Cookies.get('utm_campaign')) {
            freeform.form.utmCampaign.value = Cookies.get('utm_campaign');
        }

        if (freeform.form.utmContent !== 'undefined' && Cookies.get('utm_content')) {
            freeform.form.utmContent.value = Cookies.get('utm_content');
        }

        if (freeform.form.state !== 'undefined' && Cookies.get('location')) {
            freeform.form.state.value = Cookies.get('location').toUpperCase();
        }
    }

    function pageDetails(freeform) {
        if (freeform.form.pageUrl) {
            freeform.form.pageUrl.value = window.location;
        }
        if (freeform.form.suburb && freeform.form.dataset.suburb) {
            freeform.form.suburb.value = freeform.form.dataset.suburb
        }
        if (freeform.form.hlPackageName && freeform.form.dataset.package) {
            freeform.form.hlPackageName.value = freeform.form.dataset.package
        }
    }

    function resetForm() {
        $('.freeform-column').each(function () {
            if ($(this)[0].hasAttribute('data-ff-rule')) {
                $(this).css('display', 'none');
            }
        });
    }

    function fadeOutNotifications() {
        setTimeout(function() {
            $('.ff-form-errors, .ff-form-success').fadeOut();
        }, 5000);
        setTimeout(function() {
            $('.ff-errors').fadeOut();
        }, 15000);
    }

    function getUrlQueryParams() {
        var queryString = window.location.search || '';
        var keyValPairs = [];
        var params = {};
        queryString = queryString.substr(1);

        if (queryString.length) {
            keyValPairs = queryString.split('&');
            for (let pairNum in keyValPairs) {
                var key = keyValPairs[pairNum].split('=')[0];
                if (!key.length) {
                    continue;
                }
                if (typeof params[key] === 'undefined') {
                    params[key] = [];
                }
                params[key].push(keyValPairs[pairNum].split('=')[1]);
            }
        }

        return params;
    }

    //Customise freeform functions
    if (forms) {
        forms.each(function (position, $form) {
            let freeform = $form.freeform;

            if (freeform) {
                // push form id to data layer
                const formId = freeform.form.id;

                // If UTM Queries exist, define their values
                setUtmValues(freeform, getUrlQueryParams());

                // If applicable apply page details
                pageDetails(freeform);

                //Override Freeforms default error message
                freeform.setOption('errorBannerMessage', 'Error! Please try again.');
                freeform.setOption('successBannerMessage', 'Thanks! Submission successful.');

                //show original message on successful submit
                freeform.addOnAfterAjaxSubmit((event, form, response) => {
                    if (formId === 'mailingListForm') {
                        $('.ff-form-errors, .ff-form-success').insertBefore(
                            $('#' + formId + ' button').closest('.mailing-list-form-container')
                        );
                    } else {
                        $('.ff-form-errors, .ff-form-success').insertAfter(
                            $('#' + formId + ' button')
                        );
                    }

                    fadeOutNotifications();
                });

                //change button back to default text
                freeform.addOnSuccessfulAjaxSubmit(function (event, form, response) {
                    resetForm();
                    gtmPush('formSubmitted', formId);
                });

                if (form.formUrl) {
                    freeform.addOnSubmitCallback(form => {
                        return form.formUrl.value.includes(window.location.hostname);
                    });
                }
            }
        });
    }

    checkGA();
});
